import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
    selector: 'app-weave-button',
    templateUrl: './weave-button.component.html',
    styleUrls: ['./weave-button.component.scss'],
    standalone: false
})
export class WeaveButtonComponent implements OnInit {
  @Input() text: string = "";
  @Input() classes: string = "";
  @Input() tooltip: string = "";
  @Input() disabled: boolean = false;
  @Input() isHalf: boolean = false;
  @Input() isShort: boolean = false;
  @Input() routeName: string = null;
  @Input() routeParams: any = null;
  @Input() routerLink: string[] = null;
  @Input() queryParams: any = null;

  @Output() clicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  id: string = "";

  constructor() {
    this.id = "weave-button-" + uuidv4();
  }

  ngOnInit(): void {
  }

  click() {
    if(!this.disabled) {
      this.clicked.emit( true );
    }
  }

}
